export default __webpack_public_path__ + "static/courier-832a3b54827faefcb6014bb3f1e3b3b6.jpg";